import { render, staticRenderFns } from "./InvestmentsByState.vue?vue&type=template&id=34c31456&"
import script from "./InvestmentsByState.vue?vue&type=script&lang=ts&"
export * from "./InvestmentsByState.vue?vue&type=script&lang=ts&"
import style0 from "./InvestmentsByState.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports